/**
 * Live phone models from SC Options / Infinite Options.
 * Falls back to bundled defaults if the API is blocked.
 */
(function (w) {
  if (w.egoLoadPhoneModels) return;

  var CACHE_KEY = 'ego_phone_models_v1';
  var CACHE_MS = 24 * 60 * 60 * 1000;
  var DROPDOWN_BRAND = {
    'Apple iPhone Model': 'Apple',
    'Google Pixel Model': 'Google',
    'Your Motorola Model': 'Motorola',
    'Samsung Galaxy Model': 'Samsung'
  };

  var FALLBACK = {
    Apple: [
      'iPhone 18 ProMax (New)', 'iPhone 18 Pro (New)', 'iPhone 17 ProMax', 'iPhone 17 Air', 'iPhone 17 Pro', 'iPhone 17', 'iPhone 16e /17e',
      'iPhone 16 ProMax', 'iPhone 16 Plus', 'iPhone 16 Pro', 'iPhone 16', 'iPhone 15 ProMax', 'iPhone 15 Plus', 'iPhone 15 Pro', 'iPhone 15',
      'iPhone 14 ProMax', 'iPhone 14 Plus', 'iPhone 14 Pro', 'iPhone 14', 'iPhone 13 ProMax', 'iPhone 13 Pro', 'iPhone 13', 'iPhone 13 Mini',
      'iPhone 12 ProMax', 'iPhone 12 Pro', 'iPhone 12', 'iPhone 12 Mini', 'iPhone 11 ProMax', 'iPhone 11 Pro', 'iPhone 11',
      'iPhone XsMax', 'iPhone Xr', 'iPhone X, Xs', 'iPhone SE2/SE3 (2020/2022 Version)'
    ],
    Samsung: [
      'Galaxy S26 Ultra', 'Galaxy S26 Plus', 'Galaxy S26', 'Galaxy S25 Ultra', 'Galaxy S25 Plus', 'Galaxy S25 FE', 'Galaxy S25',
      'Galaxy S24 Ultra', 'Galaxy S24 Plus', 'Galaxy S24 FE', 'Galaxy S24', 'Galaxy S23 Ultra', 'Galaxy S23 Plus', 'Galaxy S23',
      'Galaxy S22 Ultra', 'Galaxy S22 Plus', 'Galaxy S22', 'Galaxy Z Fold 6 5g', 'Galaxy Z Flip 6 / Flip 7 FE 5g',
      'Galaxy A55 5g', 'Galaxy A35 5g'
    ],
    Google: [
      'Pixel 11 Pro XL (6.8" Screen)', 'Pixel 11 & 11 Pro (6.3" Screen)', 'Pixel 10 Pro XL (6.8" Screen)',
      'Pixel 10 & 10 Pro (6.3" Screen)', 'Pixel 10 Pro Fold', 'Pixel 10a', 'Pixel 9 Pro XL (6.8" Screen)',
      'Pixel 9a (6.3" Screen)', 'Pixel 9 & 9 Pro (6.3" Screen)', 'Pixel 8 Pro 5g', 'Pixel 8 5g', 'Pixel 8a 5g'
    ],
    Motorola: [
      'Edge 40 (2024)', 'Edge Plus (2023)', 'Edge (2022)', 'G Power 5G (2023)', 'G Play (2024)', 'G Stylus 5g (2023)', 'ThinkPhone (2023)'
    ]
  };

  function strip(t) {
    return String(t || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function readCache() {
    try {
      var raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (!o || !o.at || !o.models) return null;
      if (Date.now() - o.at > CACHE_MS) return null;
      return o.models;
    } catch (e) {
      return null;
    }
  }

  function writeCache(models) {
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify({ at: Date.now(), models: models }));
    } catch (e) {}
  }

  function parseModels(payload) {
    var out = { Apple: [], Samsung: [], Google: [], Motorola: [] };
    var opts =
      payload &&
      payload.option_product &&
      payload.option_product.option_sets &&
      payload.option_product.option_sets[0] &&
      payload.option_product.option_sets[0].options;
    if (!opts || !opts.length) return null;

    opts.forEach(function (o) {
      if (!o || o.type !== 'dropdown') return;
      var brand = DROPDOWN_BRAND[strip(o.internal_name)];
      if (!brand) return;
      (o.options_values || []).forEach(function (v) {
        var name = strip(v && v.value);
        if (name) out[brand].push(name);
      });
    });

    var total = out.Apple.length + out.Samsung.length + out.Google.length + out.Motorola.length;
    return total ? out : null;
  }

  function setModels(models) {
    w.EGO_PHONE_MODELS = models;
    if (!w.EGO_OPTIONS_DATA) w.EGO_OPTIONS_DATA = {};
    w.EGO_OPTIONS_DATA.models = models;
    try {
      document.dispatchEvent(new CustomEvent('ego:models-updated', { detail: models }));
    } catch (e) {}
  }

  function sourceUrl() {
    var el = document.querySelector('[data-ego-models-product-id]');
    var id = (el && el.getAttribute('data-ego-models-product-id')) || '3828841218151';
    var shop = (el && el.getAttribute('data-ego-models-shop')) || 'egotacticialusa.myshopify.com';
    return 'https://options.shopapps.site/v2/' + shop + '/generate_option/' + id;
  }

  w.egoLoadPhoneModels = function () {
    if (w.__egoModelsPromise) return w.__egoModelsPromise;

    var cached = readCache();
    if (cached) {
      setModels(cached);
      w.__egoModelsPromise = Promise.resolve(cached);
      // Refresh in background
      fetch(sourceUrl(), { credentials: 'omit', mode: 'cors' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (json) {
          var models = parseModels(json);
          if (models) {
            writeCache(models);
            setModels(models);
          }
        })
        .catch(function () {});
      return w.__egoModelsPromise;
    }

    setModels(FALLBACK);
    w.__egoModelsPromise = fetch(sourceUrl(), { credentials: 'omit', mode: 'cors' })
      .then(function (r) {
        if (!r.ok) throw new Error('options fetch ' + r.status);
        return r.json();
      })
      .then(function (json) {
        var models = parseModels(json);
        if (!models) throw new Error('parse failed');
        writeCache(models);
        setModels(models);
        return models;
      })
      .catch(function () {
        setModels(FALLBACK);
        return FALLBACK;
      });

    return w.__egoModelsPromise;
  };

  // Kick off early
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { w.egoLoadPhoneModels(); });
  } else {
    w.egoLoadPhoneModels();
  }
})(window);
